<template>
  <div :class="'bys-tep-map bys-tep-map--' + mapType">
    <div class="map-container__map-external">
    <l-map class="map-container__map" ref="map_ref"
           :zoomControl="leaflet_settings.zoomControl"
           :zoomSnap="leaflet_settings.zoomSnap">
      <l-tile-layer
          :url="leaflet_settings.tileLayer.url"
          :subdomains="leaflet_settings.tileLayer.subdomains"
          :attribution="leaflet_settings.tileLayer.attribution"
          :maxZoom="leaflet_settings.tileLayer.maxZoom"
      ></l-tile-layer>

      <l-geo-json ref="county_geojson_ref" :options="{onEachFeature: countyOnEachFeature, style: countyGeojsonStyle}" :geojson="county_geojson"></l-geo-json>
<!--      <l-geo-json v-for="ccc in ccc_locations_geojson" :options="{pointToLayer: cccPointToLayer}"></l-geo-json>-->
      <l-marker v-for="ccc in ccc_locations_filtered"
                :key="ccc.communitycollegename + '_marker'"
                :lat-lng="latlng(ccc.latitude, ccc.longitude)">
        <l-icon>
          <div class="map-marker map-marker--ccc">&nbsp;</div>
        </l-icon>
        <l-tooltip :options="{'direction': 'bottom', offset: [0, 12]}" class="institution-icon__institution-name">
          <div><strong>{{ ccc.communitycollegename }}</strong></div>
          <div>{{ ccc.inputaddress }}</div>
          <div>California Community College</div>
        </l-tooltip>
      </l-marker>
      <l-marker v-for="tep in tep_locations_filtered"
                :key="tep.institutionname + '_marker'"
                :lat-lng="latlng(tep.latitude, tep.longitude)">
        <l-icon>
          <div class="map-marker map-marker--tep">&nbsp;</div>
        </l-icon>
        <l-tooltip :options="{'direction': 'bottom', offset: [0, 12]}" class="institution-icon__institution-name">
          <div><strong>{{ tep.institutionname }}</strong></div>
          <div>{{ tep.address }}</div>
          <div>Type: {{ tep.institution_type }}</div>
        </l-tooltip>
      </l-marker>
    </l-map></div>
    <div class="controls-and-legend">
      <div class="stage-controls">
        <label :class="['stage-controls__control',
         'stage-controls__control--ipw',
         ((mapState === 'ipw') ? 'stage-controls__control--active' : 'stage-controls__control--inactive')]">
          <input type="radio" value="ipw" v-model="mapState">
          <span class="switch"><span class="slider"></span></span>
          <span>Show Underprepared Teacher<br> (UT) Rates<button class="definition-info" @click="active_definition = definitions.ipw_rate">ⓘ</button></span>
        </label>
        <label :class="['stage-controls__control', 'stage-controls__control--tep', ((mapState === 'tep') ? 'stage-controls__control--active' : 'stage-controls__control--inactive')]">
          <input type="radio" value="tep" v-model="mapState">
          <span class="switch"><span class="slider"></span></span>
          <span>Show Teacher Education Deserts<button class="definition-info" @click="active_definition = definitions.tep_desert">ⓘ</button></span>
        </label>
        <label :class="['stage-controls__control', 'stage-controls__control--ccc', ((mapState === 'ccc') ? 'stage-controls__control--active' : 'stage-controls__control--inactive')]">
          <input type="radio" value="ccc" v-model="mapState">
          <span class="switch"><span class="slider"></span></span>
          <span>Show Community College Support Impact<button class="definition-info" @click="active_definition = definitions.ccc_impact">ⓘ</button></span>
        </label>
      </div>
      <div class="legend legend--deserts">
        <div><span class="map-marker map-marker--tep"></span>Teacher Education Programs (TEP)<button class="definition-info" @click="active_definition = definitions.total_60_tep">ⓘ</button></div>
        <div><span class="map-marker map-marker--ccc"></span>CA Community Colleges (CCC)<button class="definition-info" @click="active_definition = definitions.total_60_ccc">ⓘ</button></div>
        <div><span class="map-swatch map-swatch--tep-desert"></span>Teacher Education Deserts<button class="definition-info" @click="active_definition = definitions.tep_desert">ⓘ</button></div>
        <div><span class="map-swatch map-swatch--ccc"></span>Teacher Education Deserts impacted by Community College Support<button class="definition-info" @click="active_definition = definitions.ccc_impact">ⓘ</button></div>

        <div class="legend__ipw">
          <div class="legend__ipw__label">UT&nbsp;Rates&nbsp;<button class="definition-info" @click="active_definition = definitions.ipw_rate">ⓘ</button>:</div>
          <div class="ipw-range">
            <div class="ipw-range__bar"></div>
            <div class="ipw-range__numbers">
              <div>&lt; 3%</div>
              <div>&lt; 6%</div>
              <div>&lt; 10%</div>
              <div>+10%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="county-data" v-if="activeCounty">
      <div class="county-data__close" @click="activeCounty = ''">×</div>
      <div class="county-data__title">{{activeCountyData.county}} County</div>
      <table>
        <tbody>
          <tr>
            <td class="data-label"># of students</td>
            <td class="data-field">{{format_stat(activeCountyData.total_student)}}</td>
          </tr>
          <tr>
            <td class="data-label">% students of color<button class="definition-info" @click="active_definition = definitions.student_poc_pct">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.student_poc_pct)}}</td>
          </tr>
          <tr>
            <td class="data-label">% students who qualify for free and reduced price lunch<button class="definition-info" @click="active_definition = definitions.student_frpm_pct">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.student_frpm_pct)}}</td>
          </tr>
          <tr>
            <td class="data-label"># of FTE Teachers<button class="definition-info" @click="active_definition = definitions.total_teacher_2122">ⓘ</button></td>
            <td class="data-field">{{format_stat(activeCountyData.total_teacher_2122)}}</td>
          </tr>
          <tr>
            <td class="data-label">% Clear<button class="definition-info" @click="active_definition = definitions.pct_clear">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.pct_clear)}}</td>
          </tr>
          <tr>
            <td class="data-label">% Out of field<button class="definition-info" @click="active_definition = definitions.pct_out_field">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.pct_out_field)}}</td>
          </tr>
          <tr>
            <td class="data-label">% Ineffective Designation<button class="definition-info" @click="active_definition = definitions.pct_ineffective">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.pct_ineffective)}}</td>
          </tr>
          <tr>
            <td class="data-label">Total # of TEPs within 60 miles of the county office<button class="definition-info" @click="active_definition = definitions.total_60_tep">ⓘ</button></td>
            <td class="data-field">{{format_stat(activeCountyData.total_60_tep)}}</td>
          </tr>
          <tr>
            <td class="data-label">Total # of CA community colleges within 60 miles of the county office<button class="definition-info" @click="active_definition = definitions.total_60_ccc">ⓘ</button></td>
            <td class="data-field">{{format_stat(activeCountyData.total_60_ccc)}}</td>
          </tr>
          <tr>
            <td class="data-label">UT rate<button class="definition-info" @click="active_definition = definitions.ipw_rate">ⓘ</button></td>
            <td class="data-field">{{format_percent(activeCountyData.ipw_rate)}}</td>
          </tr>
          <tr>
            <td class="data-label"># of vacancies<button class="definition-info" @click="active_definition = definitions.vacancies">ⓘ</button></td>
            <td class="data-field">{{format_stat(activeCountyData.vacancies)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="county-selector" v-else>
      <select class="county-selector__select" v-model="activeCounty">
        <option disabled="disabled" value="">- Select a county to view data -</option>
        <option v-for="county in ipw_vac_data" :value="county.county.toLowerCase()" :key="county.county">{{county.county}}</option>
      </select>
    </div>
    <div class="help-and-glossary">
      <button class="open-instructions" @click="show_instructions = true">Help</button>
      <button class="open-glossary" @click="show_glossary = true">Glossary</button>
    </div>
    <div class="county-click-instructions" v-if="show_instructions">
      Click a county to see statistics
      <div class="county-click-instructions__background"></div>
      <div class="county-click-instructions__box">
        <div class="county-click-instructions__inner">
          <div class="county-click-instructions__close" @click="show_instructions = false">×</div>
          <h3 class="county-click-instructions__title">Welcome to the Teacher Education Desert Map</h3>
          <div class="county-click-instructions__text">To see detailed information please click on individual counties or use the dropdown menu in the right corner to choose a county. Use the sliders on the bottom right to change between various views of the map. If you'd like clarification on what a specific term means, click on the ⓘ next to it to see a full definition and links to our sources.</div>
        </div>
      </div>
    </div>
    <div v-if="show_glossary" class="glossary">
      <div class="glossary__background"></div>
      <div class="glossary__box">
        <div class="glossary__inner">
          <div class="glossary__close" @click="show_glossary = false">×</div>
          <h3 class="glossary__title">Glossary of terms</h3>
          <div class="glossary__scroll">
          <div class="glossary__content">
            <div class="glossary__term" v-for="(term, key) in definitions" :key="key">
              <h4 class="definition__term">{{term.term}}</h4>
              <div class="definition__text" v-html="term.text"></div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active_definition" class="definition">
      <div class="definition__background"></div>
      <div class="definition__box">
        <div class="definition__inner">
          <div class="definition__close" @click="active_definition = false">×</div>
          <h3 class="definition__term">{{active_definition.term}}</h3>
          <div class="definition__text" v-html="active_definition.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'leaflet/dist/leaflet.css';

import county_geojson from "../data/california-counties.json";
import ipw_vac_data from "../data/ipw_vac_county_analytic.json"
import definitions from "../data/definitions.json"
import ccc_locations from "../data/ccc_map_data.json";
import tep_locations from "../data/tep_map_data.json";

import L from 'leaflet';
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
  LGeoJson,
} from 'vue2-leaflet';

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'Map',

  props: ['mapType'],
  data: () => {
    return {
      showDeserts: false,
      showCCCs: false,
      mapState: 'ipw',
      min_ipw: 0,
      max_ipw: 0.2,
      definitions: definitions,
      activeCounty: '',
      active_definition: false,
      show_instructions: true,
      show_glossary: false,
      county_geojson: county_geojson,
      ccc_locations: ccc_locations,
      tep_locations: tep_locations,
      ipw_vac_data: ipw_vac_data,
      desktop_padding: [300, 0],
      mobile_padding: [0, 300],
      mobile_padding_breakpoint: 650,
      leaflet_map: undefined,
      map_type: 'default',
      sixty_miles_in_meters: 96561,
      ccc_location_style: {
        fillOpacity: 0.1,
        weight: 2,
        opacity: 1,
        color: '#ffb600',
        fillColor: '#ffb600',
      },
      tep_location_style: {
        fillOpacity: 0.2,
        weight: 2,
        opacity: 1,
        color: 'rgb(0, 59, 92)',
        fillColor: 'rgb(0, 59, 92)',
      },
      leaflet_settings: {
        zoomControl: false,
        zoomSnap: 0.1,
        tileLayer: {
          url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
          subdomains: 'abcd',
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>.',
          maxZoom: 19,
        },
        icon_size: {
          default: [28, 28],
          active: [56, 56],
        }
      },
    }
  },
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    LMarker,
    LIcon,
    LGeoJson,
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize: function() {
      this.setView();
    },
    countyGeojsonStyle: function(feature) {
      // console.log('feature', feature)
      let current_county_data = ipw_vac_data.find(c => c.county.toLowerCase() === feature.properties.name.toLowerCase());

      if (this.mapState === "ipw") {

        let opac = [0, 0.2, 0.4, 0.6]
        let useopac;
        if (current_county_data.ipw_rate < 0.03) {
          useopac = opac[0];
        }
        else if (current_county_data.ipw_rate < 0.06) {
          useopac = opac[1];
        }
        else if (current_county_data.ipw_rate < 0.1) {
          useopac = opac[2];
        }
        else {
          useopac = opac[3];
        }
        return {
          fillOpacity: useopac,
          weight: 2,
          opacity: 0.5,
          fillColor: 'rgb(0, 85, 135)',
        }
      }
      else if (this.mapState === "tep") {
        /// yellow if desert
        return {
          fillOpacity: current_county_data.total_60_tep === 0 ? 0.3 : 0,
          weight: 2,
          opacity: 0.5,
          fillColor: 'rgb(255, 209, 0)',
        }
      }
      else { // cccs
        return {
          fillOpacity: current_county_data.total_60_tep === 0 ? 0.3 : 0,
          weight: 2,
          opacity: 0.5,
          fillColor: current_county_data.total_60_tep === 0 && current_county_data.total_60_ccc !== 0 ? 'rgb(0, 135, 18)' : 'rgb(255, 209, 0)',
        }
      }
    },
    countyOnEachFeature: function(feature, layer) {
      // feature, layer;
      // console.log(feature, layer)
      layer.on({'click': () => {
        // console.log('clicked feature, layer', feature, layer)
          this.activeCounty = feature.properties.name.toLowerCase()
      }})
    },
    tepPointToLayer: function(feature, latlng) {
      return L.circleMarker(latlng, {
        radius : 8,
        fillColor : "#ff7800",
        color : "#000",
        weight : 1,
        opacity : 1,
        fillOpacity : 0.8
      });
    },
    cccPointToLayer: function(feature, latlng) {
      return L.circleMarker(latlng, {
        radius : 8,
        fillColor : "#ff7800",
        color : "#000",
        weight : 1,
        opacity : 1,
        fillOpacity : 0.8
      });
    },
    latlng: L.latLng,

    log: function () {
      console.log(...arguments)
    },
    format_percent: function(val) {
      if (typeof val !== 'undefined') {
        return (Math.round(val * 1000) / 10) + "%"
      }
      return "N/D"
    },
    format_stat: function(val) {
      if (typeof val !== 'undefined' && val !== "") {
        return val.toLocaleString()
      }
      return "N/D"
    },
    setView: function (bounds) {
      if (typeof this.$refs.map_ref === 'undefined') {
        setTimeout(() => {this.setView(bounds)}, 100)
        // console.log('waiting for map to be defined');
        return;
      }
      bounds = bounds || L.latLngBounds(L.latLng(42, -114), L.latLng(32, -125))
      this.$nextTick(() => {
        let padding = this.mobile_padding;
        if (window.innerWidth > this.mobile_padding_breakpoint) {
          padding = this.desktop_padding;
        }
        this.$refs.map_ref.mapObject.invalidateSize();
        this.$refs.map_ref.mapObject.fitBounds(bounds, {
          // paddingTopLeft: [0, 0],
          paddingBottomRight: padding
        });
      });
    },
    preprocess_univ_url: function(url) {
      // http url to avoid potential broken links.
      return !/^https?:\/\//i.test(url) ? `http://${url}` : url;
    },
  },
  mounted() {
    ipw_vac_data.forEach(i => {
      if (i.ipw_rate > this.max_ipw) {
        this.max_ipw = i.ipw_rate;
      }
      if (i.ipw_rate < this.min_ipw) {
        this.min_ipw = i.ipw_rate;
      }
    })

    // console.log('i.ipw_rate range', this.min_ipw, this.max_ipw)


    // console.log('setView refs', this.$refs)
    this.setView();


    // setInterval(() => {
    //   console.log('this.$refs.map_ref.mapObject.getBounds()', this.$refs.map_ref.mapObject.getBounds());
    // }, 1000)
    // console.log('this.$refs.county_geojson_ref.mapObject', this.$refs)


    this.$refs.map_ref.mapObject.scrollWheelZoom.disable();
    let scroll_tip_vanish_timeout = undefined
    let replace_leaflet_scroll_handler = (event) => {
      event.stopPropagation();
      if (event.ctrlKey === true) {
        event.preventDefault();
        this.$refs.map_ref.mapObject.scrollWheelZoom.enable();
        this.$refs.map_ref.mapObject._container.classList.remove('map-scroll');
        setTimeout(() => {
          this.$refs.map_ref.mapObject.scrollWheelZoom.disable();
        }, 1000);
      } else {
        this.$refs.map_ref.mapObject.scrollWheelZoom.disable();
        this.$refs.map_ref.mapObject._container.classList.add('map-scroll');
        clearTimeout(scroll_tip_vanish_timeout);
        scroll_tip_vanish_timeout = setTimeout(() => {
          this.$refs.map_ref.mapObject._container.classList.remove('map-scroll');
        }, 2000);
      }
    }
    this.$refs.map_ref.$el.addEventListener('DOMMouseScroll', replace_leaflet_scroll_handler);
    this.$refs.map_ref.$el.addEventListener('mousewheel', replace_leaflet_scroll_handler);

    let window_scroll_handler = () => {
      this.$refs.map_ref?.mapObject._container.classList.remove('map-scroll');
    };

    document.addEventListener('DOMMouseScroll', window_scroll_handler)
    document.addEventListener('mousewheel', window_scroll_handler)


  },
  watch: {

  },
  computed: {
    ccc_locations_filtered: function() {
      if (this.mapState !== "ccc") {
        return [];
      }
      return this.ccc_locations;
    },
    tep_locations_filtered: function() {
      if (this.mapState === "ipw") {
        return [];
      }
      return this.tep_locations;
    },
    activeCountyData: function() {
      let data = this.ipw_vac_data.find(c => c.county.toLowerCase() === this.activeCounty.toLowerCase())
      if (data) {
        return data;
      }
      else {
        return undefined
      }
    },
    ccc_locations_geojson: function() {
      return {
        "type": "FeatureCollection",
        "name": "ccc_locations_geojson",
        "features": this.ccc_locations_filtered.map(i => {
          return {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [i.latitude, i.longitude]
            },
            "properties": {
              "communitycollegename": i.communitycollegename,
              "inputaddress": i.inputaddress,
            }
          }
        })

      }
    }
  }
}
</script>

<style lang="scss">

@import "../../node_modules/leaflet/dist/leaflet.css";

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');

@mixin transition($transition...) {
  transition: $transition;
}

@mixin transition-property($property...) {
  transition-property: $property;
}

@mixin transition-duration($duration...) {
  transition-duration: $duration;
}

@mixin transition-timing-function($timing...) {
  transition-timing-function: $timing;
}

@mixin transition-delay($delay...) {
  transition-delay: $delay;
}

@mixin nt($prop: all, $time: 0.25s, $anim: ease-in-out) {
  //
  // These are seperated to allow for multiple element selection with unquote('item, item2') syntax.
  // @include nt($el: unquote('width, opacity'));
  // You may also use single selectors.
  // @include nt($el: width);
  // Or none at all
  // @include nt;
  //
  @include transition-property($prop);
  @include transition-duration($time);
  @include transition-timing-function($anim);
}


$dark-blue-shade: #004751;
$primary-color-hover: #006b78;
$primary-color: #008293;
$light-blue-shade: #00a8bf; // used for selected items
$map-light: rgba($light-blue-shade, 0.5);
$grey: #555555;
$light-grey: #cccccc;
$text-color: #333;
$sidebar-size: 480px;
$sidebar-ext-padding: 32px;
$sidebar-int-padding: 25px;

$default-box-shadow: 1px 2px 4px rgba(0,0,0,0.5);

.bys-tep-map {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  height: 0px;
  padding-bottom: 70%;
  min-height: 840px;
  width: 100%;
  position: relative;
  color: $text-color;
  box-sizing: border-box;
  overflow: hidden;
  * {
    box-sizing: border-box;
  }
  h2, h3, h4, h5, h6, a, div, span, button {
    font-family: "Montserrat", sans-serif;
  }
}

.map-container__map-external {
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
}
.map-container__map {
  height: 100%;
  width: 100%;
}

.controls-and-legend {
  position: absolute;
  bottom: 20px;
  right: 10px;
  display: flex;
  flex-flow: column;
  gap: 6px;
  @media screen and (max-width: 650px) {
    width: calc(100% - 20px);
    bottom: 52px;
  }
}

.legend,
.stage-controls {
  display: flex;
  font-size: 14px;
  flex-flow: row nowrap;
  gap: 5px;
  //width: 500px;
  width: 320px;
  @media screen and (max-width: 650px) {
    width: 100%;
  }
  border: 1px solid rgba(0,0,0,0.15);
  z-index: 100;
  background-color: white;
  padding: 7px;
  border-radius: 4px;
  box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
}

.definition-info {
  border: none;
  background: transparent;
  cursor: pointer;
}

.legend__ipw {
  .ipw-range {
    margin: 0 3px;
  }
}

.legend__ipw__label {
  margin-right: 4px;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
}

.stage-controls {
  flex-flow: column nowrap;
}

.stage-controls__control {
  //border: 1px solid rgba(0,0,0,0.15);
  //border-radius: 2px;
  padding: 3px 5px 3px 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  //width: 180px;
  :not([disabled]) {
    cursor: pointer;
  }
  input {
    opacity: 0;
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked ~ .switch > .slider {
    background-color: #2196F3;
  }

  input:focus ~ .switch > .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked ~ .switch > .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
  }

  /* Rounded sliders */
  .slider {
    border-radius: 34px;
  }

  .slider:before {
    border-radius: 50%;
  }
}

.county-click-instructions,
.glossary,
.definition {
  z-index: 200;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.5;
}

.county-click-instructions__background,
.glossary__background,
.definition__background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.5);
  z-index: 201;
}

.county-click-instructions__box,
.glossary__box,
.definition__box {
  display: block;
  position: absolute;
  width: 500px;
  max-width: calc(100% - 20px);
  margin: 0 auto;
  padding: 10px;
  z-index: 202;
  max-height: 100%;
}


.county-click-instructions__close,
.glossary__close,
.definition__close {
  position: absolute;
  top: 14px;
  right: 7px;
  width: 30px;
  height: 30px;
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;
}

.glossary__term,
.definition__term {
  margin: 0 0 10px;
}

.county-click-instructions__title {
  margin: 0 0 10px;
}
.county-click-instructions__text {

}

.county-click-instructions__inner,
.glossary__inner,
.definition__inner {
  padding: 16px;
  background: white;
  font-size: 14px;
  border-radius: 4px;
  max-height: 600px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.15);
  box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
  display: flex;
  flex-flow: column nowrap;
}


.help-and-glossary {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  gap: 8px;
  flex-flow: row nowrap;
  z-index: 100;
}

.open-glossary,
.open-instructions {
  cursor: pointer;
  display: block;
  font-size: 14px;
  border: 1px solid rgba(0,0,0,0.15);
  background-color: white;
  padding: 7px;
  border-radius: 4px;
  box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
  color: #333;
}

.open-instructions {
  color: #333;
  //opacity: 0.8;
  border: 2px solid white;
}

.open-glossary {
  border: 2px solid rgb(0, 59, 92, 0.6);
}

.glossary__scroll {
  height: 100%;
  overflow: auto;
  padding-right: 8px;
}
.glossary__content {
}

.glossary__title {
  margin: 0 0 10px;
}

.county-selector {
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 320px;
  z-index: 100;
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
  border: 2px solid rgb(0, 59, 92, 0.6);

  //@media screen and (max-width: 650px) {
  //  width: calc(100% - 20px);
  //}
}
//
//.county-selector__title {
//  margin: 0 0 10px;
//}
.county-selector__select {
  font-size: 16px;
  font-weight: normal;
  width: 100%;
  padding: 6px 6px;
  background: white;
  border: none;
}

.county-data {
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 320px;
  @media screen and (max-width: 650px) {
    width: calc(100% - 20px);
  }
  font-size: 14px;
  border: 1px solid rgba(0,0,0,0.15);
  z-index: 100;
  background-color: white;
  padding: 7px;
  border-radius: 4px;
  box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
  .county-data__title {
    padding: 8px 32px 8px 8px;
    font-size: 16px;
    text-transform: uppercase;
  }
  .county-data__close {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 30px;
    height: 30px;
    font-size: 20px;
    line-height: 30px;
    cursor: pointer;
  }
  table {
    padding: 0;
    margin-top: 2px;
    border-collapse: collapse;
    td {
      padding: 6px 8px;
    }
    //td:first-child {
    //  padding-left: 0;
    //}
    //td:last-child {
    //  padding-right: 0;
    //}
    //tr:last-child {
    //  td {
    //    padding-bottom: 0;
    //  }
    //}
    //tr:first-child {
    //  td {
    //    padding-top: 0;
    //  }
    //}
    tr:nth-child(odd) {
      background-color: rgba(0, 124, 191, 0.1)
    }
  }
  &.county-data--nocounty {
    font-size: 16px;
    //font-weight: bold;
    text-align: center;
  }
}


.map-container__map.map-scroll:before {
  opacity: 1;
  .whereabouts-search-map--has-message & {
    opacity: 0;
  }
}

.map-container__map.map-scroll:after {
  opacity: 0.45;
  .whereabouts-search-map--has-message & {
    opacity: 0;
  }
}

.map-container__map {
  &:before,
  &:after {
    opacity: 0;
    transition: opacity 0.5s ease;
    pointer-events: none;
    position: absolute;
  }

  &:before {
    content: 'Use ctrl + scroll to zoom the map';
    top: 50%;
    left: 50%;
    z-index: 999;
    font-size: 22px;
    line-height: 32px;
    padding: 20px;
    box-sizing: border-box;
    max-width: 100%;
    width: 450px;
    transform: translate(-50%, -50%);
  }
  &:after {
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    content: '';
    background: #ffffff;
    z-index: 998;
  }


}

.map-marker {
  width: 6px;
  height: 6px;
  margin: 3px;
  background: grey;
  border-radius: 50%;
}

.map-marker--tep {
  background: #2774AE;
}

.map-marker--ccc {
  background: #FF00A5;
}

.data-field {
  white-space: nowrap;
}

.ipw-range__numbers {
  display: flex;
  flex-flow: row nowrap;
  > div {
    text-align: center;
    flex-basis: 25%;
    padding: 0 3px;
    font-size: 12px;
  }
}

.ipw-range__bar {
  height: 20px;
  width: 200px;
  flex-grow: 1;
  background: linear-gradient(to right, rgba(0, 59, 92, 0) 0%,
      rgba(0, 59, 92, 0) 25%, rgba(0, 59, 92, 0.2) 25%,
      rgba(0, 59, 92, 0.2) 50%, rgba(0, 59, 92, 0.4) 50%,
      rgba(0, 59, 92, 0.4) 75%, rgba(0, 59, 92, 0.6) 75%,
      rgba(0, 59, 92, 0.6) 100%);
}

.legend--ipw {
  align-items: center;
}

.legend--deserts {
  display: flex;
  flex-flow: column nowrap;
  .map-marker,
  .map-swatch {
    display: inline-block;
  }
  .map-marker {
    margin: 0 7px 0 3px;
    width: 6px;
    height: 6px;
  }
  .map-swatch {
    margin-right: 5px;
  }
  > div {
    display: flex;
    align-items: center;
  }
}

.map-swatch {
  height: 10px;
  width: 10px;
  background-color: grey;
  flex-shrink: 0;
}

.map-swatch--tep-desert {
  background-color: rgb(255, 209, 0, 0.3);
}
.map-swatch--ccc {
  background-color: rgba(0, 135, 18, 0.3);
}

</style>
